export const WO_TYPES = { PM01: 'PM01', PM02: 'PM02', PM03: 'PM03' };

export const WO_TYPE_LABELS = {
  PM01: 'Planned',
  PM02: 'Recurring',
  PM03: 'Break In'
};

export const WO_TYPE_COLORS = {
  PM01: '#2563eb',
  PM02: '#0ea5e9',
  PM03: '#f59e0b'
};

export const STATUSES = ['New', 'In Progress', 'Complete', 'TECO'];

export const statusColors = {
  'New': '#f59e0b',
  'In Progress': '#3b82f6',
  'Complete': '#10b981',
  'TECO': '#065f46'
};

export const OPERATION_STATUSES = ['New', 'In Progress', 'Complete'];

export const priorityColors = {
  Normal: '#3b82f6',
  Push: '#f59e0b',
  High: '#f59e0b'
};

export const PRIORITIES = ['Normal', 'Push'];

export const FREQUENCIES = [
  '1 Daily',
  '1 Weekly',
  '2 Weekly',
  '1 Month',
  '3 Months',
  '6 Months',
  '1 Year',
  '2 Years',
  '3 Years',
  '5 Years',
  '10 Years'
];

export const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-input)', color: 'var(--text-primary)', fontSize: 13, outline: 'none' };

export const ROLES = ['user', 'supervisor', 'admin'];

export const ROLE_LABELS = {
  user: 'Standard Account',
  staff: 'Standard Account',
  supervisor: 'Supervisor',
  admin: 'Administrator'
};

export const ROLE_COLORS = {
  user: '#6b7280',
  staff: '#6b7280',
  supervisor: '#f59e0b',
  admin: '#2563eb'
};
